/* eslint-disable no-restricted-imports */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { PriceDisplay } from '@/components/blocks/PriceDisplay';
import {
	productDetailsPriceListSX,
	productDetailsPriceOfferSX,
	productDetailsPriceSX,
} from '@/components/content/ProductDetails/parts/CompleteLook/style/prices';

import { useProductDetails } from '@/data/Content/ProductDetails';
import { useSkuListTable } from '@/data/Content/SkuListTable';
import { ContentContext } from '@/data/context/content';
import { useLocalization } from '@/data/Localization';
import { ProductType } from '@/data/types/Product';
import { getProductDisplayInfo } from '@/utils/getProductDisplayInfo';
import { isKitOrBundleType } from '@/utils/productIsA';
import { Stack, Typography } from '@mui/material';
import { calculateProductPrices } from 'integration/utils/calculateProductPrices';
import { FC, useContext, useMemo } from 'react';

export const PricesProduct: FC<{ productItem: ProductType }> = ({ productItem }) => {
	const localization = useLocalization('PriceDisplay');
	const { offer, list, currency } = useMemo<{
		offer: number;
		list: number;
		currency: string;
		min: number;
	}>(() => {
		const prices = productItem.productPrice;
		const defaults = { offer: 0, list: 0, currency: '' };
		return { ...defaults, ...prices, min: productItem?.productPrice.min || 0 };
	}, [productItem.productPrice]);

	const { price, priceWithoutOffer } = calculateProductPrices({
		list,
		offer,
		ribbons: productItem?.ribbons ?? [],
	});

	return (
		<Stack direction="column" sx={{ marginTop: '5px', width: '70px' }}>
			{offer > 0 && offer === list ? (
				<Typography
					component="span"
					data-testid="offer-price"
					id="offer-price"
					sx={productDetailsPriceSX}
				>
					<PriceDisplay currency={currency} min={price} />
				</Typography>
			) : offer > 0 && offer < list ? (
				<Typography
					component="span"
					data-testid="offer-price"
					id="offer-price"
					sx={productDetailsPriceOfferSX}
				>
					<PriceDisplay currency={currency} min={price} />
				</Typography>
			) : null}

			{offer > 0 && offer < list ? (
				<Typography
					component="span"
					sx={productDetailsPriceListSX}
					data-testid="list-price"
					id="list-price"
				>
					<PriceDisplay currency={currency} min={priceWithoutOffer} />
				</Typography>
			) : null}

			{offer === 0 ? (
				<Typography variant="h5" component="span" data-testid="no-price" id="no-price">
					{localization.Labels.Pending.t()}
				</Typography>
			) : null}
		</Stack>
	);
};
